import { css as _css } from "@emotion/core";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './popup.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var POPUP_ROOT = 'allhomes-watchlist-popup';
var TOP_OFFSET = 15;
var ARROW_MARGIN = 20;
var calculatePosition = (align, container, button) => {
  if (!(container && button)) {
    return {};
  }
  var target = align === 'right' ? container.width - ARROW_MARGIN : container.width / 2;
  var left = window.scrollX + Math.max(0, Math.min(button.left - target - button.width / 2 + ARROW_MARGIN, window.innerWidth - container.width));
  var arrow = window.scrollX + button.left + button.width / 2 - left;
  var top = window.scrollY + button.bottom + TOP_OFFSET;
  return {
    left,
    top,
    arrow
  };
};
var AllhomesWatchlistButtonPopup = _ref => {
  var buttonRef = _ref.buttonRef,
    align = _ref.align,
    style = _ref.style,
    title = _ref.title,
    message = _ref.message,
    onSignUp = _ref.onSignUp,
    onSignIn = _ref.onSignIn,
    onClose = _ref.onClose;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    popupRoot = _useState2[0],
    setPopupRoot = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    containerNode = _useState4[0],
    setContainerNode = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    position = _useState6[0],
    setPosition = _useState6[1];
  var containerRect = containerNode && containerNode.getBoundingClientRect();
  var containerRef = useCallback(node => {
    if (node) {
      setContainerNode(node);
    }
  }, []);
  var notifyResize = useCallback(() => {
    if (buttonRef) {
      var newPosition = calculatePosition(align, containerRect, buttonRef.getBoundingClientRect());
      if (!isEqual(newPosition, position)) {
        setPosition(newPosition);
      }
    }
  }, [align, buttonRef, containerRect, position]);
  useEffect(() => {
    notifyResize();
  }, [notifyResize]);
  useEffect(() => {
    window.addEventListener('resize', notifyResize, {
      passive: true
    });
    return () => window.removeEventListener('resize', notifyResize);
  });
  var closePopup = evt => {
    if (containerNode && !containerNode.contains(evt.target)) {
      onClose();
    }
  };

  // Create a root element into which to render the popup, outside the main render tree
  useEffect(() => {
    if (!popupRoot) {
      var root = document.getElementById(POPUP_ROOT);
      if (!root) {
        root = document.createElement('div');
        root.id = POPUP_ROOT;
        document.body.appendChild(root);
      }
      setPopupRoot(root);
    }
  }, [popupRoot]);
  useEffect(() => {
    document.addEventListener('mousedown', closePopup);
    return () => document.removeEventListener('mousedown', closePopup);
  });
  var _ref2 = position || {},
    left = _ref2.left,
    top = _ref2.top,
    arrow = _ref2.arrow;
  var visibility = left != null && top != null ? 'visible' : 'hidden';
  var isSqueezed = style === 'squeezed';
  var renderPopup = () => ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.popup, styles.arrowPosition(arrow), isSqueezed && styles.squeezed]),
    style: {
      left,
      top,
      visibility
    },
    ref: containerRef
  }, ___EmotionJSX("button", {
    type: "button",
    onClick: onClose,
    css: styles.closeButton,
    "aria-label": "Close"
  }, ___EmotionJSX(CloseIcon, {
    size: "small"
  })), ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.title, isSqueezed && styles.squeezedTitle])
  }, title), ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.message, isSqueezed && styles.squeezedMessage])
  }, message), ___EmotionJSX("div", {
    css: styles.buttonGroup
  }, ___EmotionJSX("div", {
    css: styles.buttonWrapper
  }, ___EmotionJSX(Button, {
    css: styles.button,
    onClick: onSignUp
  }, "Sign me up")), ___EmotionJSX("div", {
    css: styles.buttonWrapper
  }, ___EmotionJSX(Button, {
    css: styles.button,
    appearance: "ghost",
    onClick: onSignIn
  }, "Log in"))));

  // Use React Portals to render the popup into the root created, once it's actually there
  return popupRoot ? /*#__PURE__*/createPortal(renderPopup(), popupRoot) : null;
};
AllhomesWatchlistButtonPopup.propTypes = {
  buttonRef: PropTypes.instanceOf(PropTypes.Element),
  onClose: PropTypes.func,
  onSignUp: PropTypes.func,
  onSignIn: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  align: PropTypes.oneOf(['right', 'center']),
  style: PropTypes.oneOf(['normal', 'squeezed'])
};
AllhomesWatchlistButtonPopup.defaultProps = {
  onClose: () => {},
  onSignUp: () => {},
  onSignIn: () => {},
  title: null,
  message: null,
  align: 'center',
  style: 'normal',
  buttonRef: undefined
};
export default AllhomesWatchlistButtonPopup;